export type StatusType = 'idle' | 'loading' | 'success' | 'error';

export interface StatusState {
  type: StatusType;
  message: string;
}

export function createStatusElement(): HTMLDivElement {
  const container = document.createElement('div');
  container.id = 'status-container';
  container.className = 'status-toast';
  container.hidden = true;
  return container;
}

export function updateStatus(container: HTMLElement, state: StatusState): void {
  container.className = `status-toast status-${state.type}`;
  container.textContent = state.message;
  container.hidden = state.type === 'idle';
}

export function showLoading(container: HTMLElement, message = 'Writing dismissal to Lakebase...'): void {
  updateStatus(container, { type: 'loading', message });
}

export function showSuccess(container: HTMLElement, message = 'Dismissal written to Lakebase'): void {
  updateStatus(container, { type: 'success', message });
}

export function showError(container: HTMLElement, message: string): void {
  updateStatus(container, { type: 'error', message });
}

export function clearStatus(container: HTMLElement): void {
  updateStatus(container, { type: 'idle', message: '' });
}
